export default "__VITE_ASSET__d2744c08__"